import { ADMIN_CLICKED, ADMIN_TOGGLED } from '../actions/actionTypes';

const initialState = {
  panelVisible: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case ADMIN_CLICKED:
      return {
        ...state,
        panelVisible: !state.panelVisible,
      };
    case ADMIN_TOGGLED:
      return {
        ...state,
        adminMode: !state.adminMode,
      }
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/admin.js